import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK_UNITS = ["個", "本", "玉", "kg", "g", "L", "ml", "p", "パック", "箱", "袋"];

const getAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// 発注単位マスタ (order_units コレクション) から単位名リストを取得するフック
// 取得失敗 / 空配列のときは FALLBACK_UNITS を返す
export function useOrderUnits() {
  const [units, setUnits] = useState(FALLBACK_UNITS);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/order-units`, getAuthHeaders())
      .then((r) => {
        if (!mounted) return;
        const list = Array.isArray(r.data) ? r.data : [];
        const names = list.map((u) => u.name).filter(Boolean);
        setUnits(names.length > 0 ? names : FALLBACK_UNITS);
      })
      .catch(() => {
        if (mounted) setUnits(FALLBACK_UNITS);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return units;
}
